import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import WhatIsSection from './components/WhatIsSection';
import WhyChooseSection from './components/WhyChooseSection';
import PopularCategories from './components/PopularCategories';
import LatestFindsSection from './components/LatestFindsSection';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <WhatIsSection />
        <WhyChooseSection />
        <PopularCategories />
        <LatestFindsSection />
        <SafetySection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}